import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/apiClient";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { QrCode, MagnifyingGlass } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Scan() {
  const navigate = useNavigate();
  const [serial, setSerial] = useState("");

  const find = async () => {
    if (!serial) return;
    const { data } = await api.get(`/search?q=${encodeURIComponent(serial)}`);
    if (data.tyres?.length) navigate(`/tyres/${data.tyres[0].id}`);
    else if (data.vehicles?.length) navigate(`/vehicles/${data.vehicles[0].id}`);
    else toast.error("No tyre or vehicle found for that code");
  };

  return (
    <div className="mx-auto max-w-md space-y-6">
      <div>
        <div className="overline text-amber-500">Field Tool</div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">QR / Barcode Scan</h1>
        <p className="mt-1 text-sm text-zinc-400">Scan a tyre or vehicle QR, or enter its code manually to open its profile.</p>
      </div>

      <div className="relative flex aspect-square items-center justify-center rounded-md border border-zinc-800 bg-zinc-950">
        <div className="absolute inset-8 rounded-md border-2 border-dashed border-amber-500/50" />
        <div className="absolute left-8 right-8 h-0.5 animate-pulse bg-amber-500" />
        <QrCode size={80} weight="thin" className="text-zinc-700" />
      </div>

      <div className="flex gap-2">
        <div className="flex flex-1 items-center gap-2 rounded-sm border border-zinc-800 bg-zinc-950 px-3">
          <MagnifyingGlass size={16} className="text-zinc-500" />
          <Input data-testid="scan-input" value={serial} onChange={(e) => setSerial(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && find()}
            placeholder="Enter serial / fleet #" className="border-0 bg-transparent px-0 focus-visible:ring-0" />
        </div>
        <Button data-testid="scan-find-btn" onClick={find} className="bg-amber-500 font-bold text-zinc-950 hover:bg-amber-400">Open</Button>
      </div>
    </div>
  );
}
